export enum MAPBOX_MAP_STYLE {
  Streets = 'mapbox://styles/mapbox/streets-v12',
  Satellite = 'mapbox://styles/mapbox/satellite-streets-v12',
  /** Светлая схема (для кастомизации скриншота) */
  Light = 'mapbox://styles/mapbox/light-v11',
  /** Минимальная светлая/белая схема (для кастомизации скриншота) */
  White = 'mapbox://styles/mapbox/light-v11',
}

const LEGACY_FUSCAR_STREETS_STYLE = 'mapbox://styles/fuscar/clxrzrzzk003c01pf57wx7q05';
const LEGACY_FUSCAR_SATELLITE_STYLE = 'mapbox://styles/fuscar/clxrztxfk00pn01pcdh5455vc';
const LEGACY_MARIIAMARIIA_STREETS_STYLE =
  'mapbox://styles/mariiamariia/cmpo06so7001t01r1e4x03x0j';

const CURRENT_MAPBOX_STYLES = new Set<string>(Object.values(MAPBOX_MAP_STYLE));

/** Maps legacy board.style URLs (fuscar) to current Mapbox styles after account migration. */
export function normalizeMapboxStyleUrl(
  style: string | MAPBOX_MAP_STYLE | null | undefined,
): MAPBOX_MAP_STYLE {
  if (!style) {
    return MAPBOX_MAP_STYLE.Streets;
  }

  const value = String(style).trim();

  if (CURRENT_MAPBOX_STYLES.has(value)) {
    return value as MAPBOX_MAP_STYLE;
  }

  if (
    value === LEGACY_FUSCAR_SATELLITE_STYLE ||
    value.includes('fuscar/clxrztxfk') ||
    value.includes('clxrztxfk')
  ) {
    return MAPBOX_MAP_STYLE.Satellite;
  }

  if (
    value === LEGACY_MARIIAMARIIA_STREETS_STYLE ||
    value.includes('mariiamariia/cmpo06') ||
    value.includes('cmpo06so7001t01r1e4x03x0j')
  ) {
    return MAPBOX_MAP_STYLE.Streets;
  }

  if (
    value === LEGACY_FUSCAR_STREETS_STYLE ||
    value.includes('fuscar/') ||
    value.includes('clxrzrzzk')
  ) {
    return MAPBOX_MAP_STYLE.Streets;
  }

  if (value.toLowerCase().includes('satellite')) {
    return MAPBOX_MAP_STYLE.Satellite;
  }

  return MAPBOX_MAP_STYLE.Streets;
}

export const OwnershipByCode = {
  HakMilik: 1,
  HakGunaBangunan: 2,
  HakPakai: 3,
  HakGunaUsaha: 4,
  HakPengelolaan: 5,
  HakWakaf: 6,
  TanahUlayat: 7,
  TidakTerdefinisi: 8,
  HakHakLain: 9,
};

export const OwnershipByColor = {
  [OwnershipByCode.HakMilik]: '#FDE725',
  [OwnershipByCode.HakGunaBangunan]: '#287D8E',
  [OwnershipByCode.HakPakai]: '#29AF7F',
  [OwnershipByCode.HakGunaUsaha]: '#95D840',
  [OwnershipByCode.HakPengelolaan]: '#440154',
  [OwnershipByCode.HakWakaf]: '#404788',
  [OwnershipByCode.TanahUlayat]: '#2D708E',
  [OwnershipByCode.TidakTerdefinisi]: '#E5E5E8',
  [OwnershipByCode.HakHakLain]: '#5E5C7D',
};

export const OwnershipByTitle = {
  [OwnershipByCode.HakMilik]: 'Hak Milik',
  [OwnershipByCode.HakGunaBangunan]: 'Hak Guna Bangunan',
  [OwnershipByCode.HakPakai]: 'Hak Pakai',
  [OwnershipByCode.HakGunaUsaha]: 'Hak Guna Usaha',
  [OwnershipByCode.HakPengelolaan]: 'Hak Pengelolaan',
  [OwnershipByCode.HakWakaf]: 'Hak Wakaf',
  [OwnershipByCode.TanahUlayat]: 'Tanah Ulayat',
  [OwnershipByCode.TidakTerdefinisi]: 'Tidak terdefinisi',
  [OwnershipByCode.HakHakLain]: 'Hak-hak lain',
};

export const PriceLayersHeatmap = [
  '#FDE725',
  '#DCE319',
  '#B8DE29',
  '#95D840',
  '#73D055',
  '#55C667',
  '#3CBB75',
  '#29AF7F',
  '#20A387',
  '#1F968B',
  '#238A8D',
  '#287D8E',
  '#2D708E',
  '#33638D',
  '#39568C',
  '#404788',
  '#453781',
  '#482677',
  '#481567',
  '#440154',
];
